import { gql } from "apollo-angular";

export const FIF = gql`
  fragment FIF on Faq {
    hTag
    hTagId
    question
    answer
    showSchema
  }`;
